import { render, staticRenderFns } from "./tournament.vue?vue&type=template&id=465b38d8"
import script from "./tournament.vue?vue&type=script&lang=js"
export * from "./tournament.vue?vue&type=script&lang=js"
import style0 from "./tournament.vue?vue&type=style&index=0&id=465b38d8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports